import DoceboAPI, { DoceboCatalogueView } from '@/lib/DoceboAPI';
import { Building, Catalogue } from '@/types';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

interface LocalState {
  catalogueViews: { [catalogueId: string]: DoceboCatalogueView };
}

Vue.use(Vuex);

const doceboAPI = DoceboAPI.instance;

const namespaced = true;

const localState: LocalState = {
  catalogueViews: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<LocalState, any> = {
  getConditionalCataloguesForBuilding: (
    _state,
    _getters,
    rootState,
    rootGetters
  ) => (buildingId: string): Catalogue[] => {
    const building: Building = rootState.config.buildings.find(
      (b: Building) => b.id === buildingId
    );
    const buildingCataloguesWithinUserConditions = building?.catalogues.filter(
      (catalogue) =>
        rootGetters['user/isCatalogueWithinUserConditions'](
          catalogue.displayConditions
        )
    );
    return buildingCataloguesWithinUserConditions || [];
  },
};

const mutations: MutationTree<LocalState> = {
  SET_CATALOGUE_VIEW_ITEM: (
    state,
    payload: {
      catalogueId: number;
      catalogueData: DoceboCatalogueView;
    }
  ) => {
    Vue.set(state.catalogueViews, payload.catalogueId, {
      ...payload.catalogueData,
      catalogueId: payload.catalogueId,
    });
  },
};

const actions: ActionTree<LocalState, unknown> = {
  GET_CATALOGUE_VIEW: (context, catalogueId: number): Promise<void> =>
    doceboAPI.getCatalogueView(catalogueId).then((catalogueData) => {
      context.commit('SET_CATALOGUE_VIEW_ITEM', {
        catalogueId,
        catalogueData,
      });
    }),
};

export { namespaced, localState as state, getters, mutations, actions };
